'use client';

import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Fade from '@mui/material/Fade';
import IconButton from '@mui/material/IconButton';
import Modal from '@mui/material/Modal';
import { type FC, type PropsWithChildren, useCallback, useState } from 'react';

export const CustomModal: FC<PropsWithChildren> = ({ children }) => {
  const [open, setOpen] = useState(false);
  const handleOpen = useCallback(() => {
    setOpen(true);
  }, []);
  const handleClose = () => setOpen(false);

  return (
    <Box
      component="div"
      sx={{ display: 'flex', flexDirection: 'column', justifyItems: 'center' }}
    >
      <Button
        onClick={handleOpen}
        sx={{ borderRadius: '100%', width: '7rem', height: '7rem' }}
      >
        <AddIcon fontSize="large" />
      </Button>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Fade in={open}>
          <Box
            sx={{
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: 'fit-content',
              overflow: 'hidden',
              bgcolor: 'background.paper',
              boxShadow: 24,
              borderRadius: '4px',
            }}
            component="article"
            position="absolute"
          >
            <Box component="div" position="relative">
              <Box
                component="div"
                position="absolute"
                top={4}
                right={4}
                zIndex={10}
              >
                <IconButton onClick={handleClose}>
                  <CloseIcon />
                </IconButton>
              </Box>
              {children}
            </Box>
          </Box>
        </Fade>
      </Modal>
    </Box>
  );
};
